import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpInterceptor,
} from '@angular/common/http';
import { from, lastValueFrom, Observable } from 'rxjs';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Router } from '@angular/router';
import { UserRolesInt } from '../models/users';
import { NavigationService } from '../services/navigation.service';
import { Entities } from '../models/globals';
import { AuthenticationService } from '../services/authentication.service';

@Injectable()
export class UserDepAccessInterceptor implements HttpInterceptor {

  constructor(private snackBar: MatSnackBar, private router: Router, private navServive: NavigationService, private authenticationService: AuthenticationService) {}

  intercept(req: HttpRequest<any>, next: HttpHandler) {
    // convert promise to observable using 'from' operator
    if(req.headers.get('checkUserDepAccess')){
      return from(this.handle(req, next))
    } else {
      return next.handle(req)
    }
  }

  async handle(req: HttpRequest<any>, next: HttpHandler) {
    let depName = req.headers.get('checkUserDepAccess')
    if(!depName){
      return lastValueFrom(next.handle(req));
    }
    let userRole = await this.authenticationService.checkUserDeploymentAccess(depName)
    if(userRole == -1){
      this.authenticationService.logout();
      this.router.navigate(['Login']);
    }
    let currentEntity = this.navServive.getCurrentEntity();
    if(userRole == UserRolesInt.JobOperator) {
      if(currentEntity == Entities.Deployments || currentEntity == Entities.Users || currentEntity == Entities.Applications || currentEntity == Entities.Reports) {
        this.snackBar.open(`You do not have access to ${currentEntity} of deployment ${depName}`, 'Ok',{
          duration: 5000
        })
        this.router.navigate(['/Jobs List']);
      } else {
        return lastValueFrom(next.handle(req));
      }
    } else {
      return lastValueFrom(next.handle(req));
    }
  }
}
